import * as DashboardApi from "../../../../apiCall/dashboard/index.js";
import {getNoData, setProjectTtl} from "../../items/index.js";
import u from "../../../../util/index.js";
import {BridgeSend, isMobile} from "../../event.js";
import Widget from "../widget.js";
import {subscribeWidget} from "../../../main-socket/index.js";
import {WIDGET} from "../../widgetConstants.js";

export class FileWidget extends Widget {

    async setup(props) {
        return super.setup(props);
    }




    async getData(props) {
        if (!this.$props.COLABO_SRNO) return true;

        const inputData = {
            ...this.$props.pageData,
            COLABO_SRNO: this.$props.COLABO_SRNO,
            RENEWAL_YN: "Y",
        }

        return await super.checkDataVersion(inputData)
    }

    async getDBData(inputData) {
        const data = await DashboardApi.getApi(this.$props.API_KEY, inputData)
        this.$props.pageData.NEXT_YN = u.n2v(data.NEXT_YN, "N");
        return {
            recordData: data[this.$props.RECORD]
        };
    }

    async render() {
        const $FileList = $(this.$target).find('.widget-article-list');

        if (this.$props.data?.length === 0) {
            $FileList.html(getNoData('file'));
            return;
        }

        $FileList.html(''); //페이징 처리 후 제거
        $FileList.drawListHelper({
            pageData: this.$props.pageData,
            nextYn: this.$props.pageData.NEXT_YN,
            records: this.$props.data,
            noDataHtml: getNoData('file'),
            callback: {
                item: getProjectFileHtmByRecord,
                final: this.mounted.bind(this)
            }
        })
    }

    mounted() {
        super.mounted();

        $(this.$target).find('.widget-article-list').removeClass('dash-pending')
        $(this.$target).find('.dash-num-pending').remove()
        subscribeWidget({
            USER_ID: _USER_ID,
            COLABO_SRNO: this.$props.COLABO_SRNO,
            TYPE: WIDGET.FILE.SRNO
        })
    }


    setEvent() {
        $(this.$target).off('click').on('click', (e) => {
            const $eTarget = $(e.target);
            if ($eTarget.closest('.js-file-item').length > 0) {
                const $fileItem = $eTarget.closest('.js-file-item');
                const viewerFile = Often.getAttrs($fileItem);
                const isImage = ImageUtil.isImageType(viewerFile[0]);
                if (isMobile) {
                    const jsonData = {
                        CODE: "FILE",
                        ATCH_SRNO: $fileItem.attr('atch_srno'),
                        FILE_DOWN_URL: $fileItem.attr('img_path'),
                        FILE_NM: $fileItem.attr('orcp_file_nm'),
                    };
                    BridgeSend(jsonData);
                } else {
                    isImage && !Often.isFunc(Func.ENTER.IMG_TO_DOCVIEWER) ? ImageViewer.openImage("POST", viewerFile, 0) : FileUtil.openFile("DOC-VIEWER", viewerFile);
                }
            }
        })
    }


//catch
// $item.find('.title').text('');
// $item.find('.button-project-change').addClass('d-none');
// $item.find('.direct').addClass('d-none');
// $item.find('.widget-article-list, .js-widget-article-list').html(getNoData('notGet'));

}

/*파일함 아이템을 dom으로 변환하는 함수*/
const getProjectFileHtmByRecord = (allPostsArray) => {
    return allPostsArray && allPostsArray.map(getFileItem).join('');
}


const getFileItem = (item) => {
    const {
        RAND_KEY,
        ATCH_URL,
        COLABO_COMMT_SRNO,
        COLABO_SRNO,
        ATCH_SRNO,
        ORCP_FILE_NM,
        FILE_SIZE,
        FILE_TYPE,
        RGSN_DTTM,
        RGSR_NM,
        WIDTH,
        HEIGHT,
        THUM_IMG_PATH,
    } = item

    const filetype = FILE_TYPE.toLowerCase() === 'img' ? 'image' : FILE_TYPE.toLowerCase();
    const time = Time.format(RGSN_DTTM, 'type1');
    const filesize = FileUtil.getFileSize(FILE_SIZE);

    return `<li class="js-file-item" rand_key="${RAND_KEY}" thum_img_path="${THUM_IMG_PATH}" width="${WIDTH}" height="${HEIGHT}" orcp_file_nm="${ORCP_FILE_NM}" colabo_srno="${COLABO_SRNO}" colabo_commt_srno="${COLABO_COMMT_SRNO}" atch_srno="${ATCH_SRNO}" img_path="${ATCH_URL}" file_type="${FILE_TYPE}" file_size="${FILE_SIZE}">
                <div class="file-extension all-file-extension-${filetype}"></div>
                <div class="widget-file-info">
                    <dl>
                        <dt><span class="widget-file-info-name">${ORCP_FILE_NM}</span> <span class="widget-file-info-size">${filesize}</span></dt>
                        <dd><span class="widget-file-info-author">${RGSR_NM}</span><span class="widget-file-info-date">${time}</span></dd>
                    </dl>
                </div>                 
            </li>`
}

